import { createVuetify } from "vuetify"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"
import { aliases, md } from "vuetify/iconsets/md"
import { en, nl } from "vuetify/locale"

const customIcons = {
  asset: "dns",
  assetTag: "tag",
  assetCondition: "assignment_turned_in",
  assetTemplates: "bookmarks",
  assetTemplate: "bookmark",
  assetStructure: "account_tree",
  assetRelation: "link",
  assetExternalKey: "vpn_key",
  assetMeasurement: "speed",
  assetSmartMeasurement: "cloud_download",
  lookupType: "list",
  lookupValue: "list",
  componentType: "category",
  listValue: "list",

  general: "info",
  dashboard: "home",
  admin: "category",
  import: "upload",
  map: "map",
  contract: "receipt_long",
  risk: "report",
  riskSetting: "speed",
  finance: "euro",
  financeMyp: "timeline",
  dataQuality: "data_usage",
  shared: "share",

  ticket: "description",
  ticketCost: "receipt",
  inspection: "task_alt",
  inspectionAnalysis: "checklist",
  action: "build",
  malfunction: "notifications",
  nen3140: "bolt",
  nen1010: "bolt",

  organization: "account_balance",
  customer: "account_balance",
  supplier: "group",
  label: "label",

  domain_pumping_stations: "water_drop",
  domain_civil: "home_repair_service",

  users: "groups",
  user: "person",
  apiKey: "key",
  support: "help_outline",

  analytics: "show_chart",
  releaseNotes: "new_releases",
  scripts: "code",
  securityLogs: "security",
  mutationLogs: "manage_history",
  mutation: "history",

  adminPanel: "admin_panel_settings",

  issues: "recent_actors",
  overview: "table_view",
  settings: "settings",

  componentType_VACUUM: "air",
  componentType_IMPELLER: "radio_button_unchecked",
  componentType_PUMP: "water_drop",
  componentType_ELECTRIC: "electric_bolt",
  componentType_MECHANIC: "plumbing",
  componentType_CONSTRUCTION: "home",
  componentType_GENERAL: "label",

  smartMeasurements: "insights",
}

const customColors = {
  customer: "#3F51B5",
  supplier: "#2196F3",
  label: "#212121",

  domain_pumping_stations: "#2196F3",
  domain_civil: "#757575",

  admin: "#9C27B0",

  action: "#F57F17",
  inspection: "#1B5E20",
  malfunction: "#C10003",
  nen3140: "#800080",
  nen1010: "#800080",

  grey: "#46413e",
}

/**
 * SAM Generic
 * black - #000000
 * grijs - #46413e
 * beige - #e8d2c9
 */

export default defineNuxtPlugin(({ vueApp }) => {
  const vuetify = createVuetify({
    ssr: true,
    components: {
      ...components,
    },
    directives,
    icons: {
      defaultSet: "md",
      aliases: {
        ...aliases,
        ...customIcons,
      },
      sets: { md },
    },

    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          dark: false,
          colors: {
            /**
             * nevel blauw - #6e8bc7
             * hemel blauw - #496cae
             * zee blauw - #22417a
             * nacht blauw - #112750
             */
            primary: "#496cae",
            secondary: "#22417a",
            tertiary: "#112750",
            quaternary: "#6e8bc7",
            background: "#f5f5f5",
            error: "#C10015",
            success: "#21BA45",
            info: "#31CCEC",
            warning: "#F0AD4E",
            accent: "#FFFDE7",
            ...customColors,
            // Before rebranding colors
            // primary: "#006ca9",
            // secondary: "#009cd1",
            // tertiary: "#002440",
          },
        },
        dark: {
          dark: true,
          colors: {
            primary: "#496cae",
            secondary: "#22417a",
            tertiary: "#112750",
            quaternary: "#1d3d78",
            background: "#0d1117",
            surface: "#21262d",
            error: "#DC143C",
            success: "#21BA45",
            info: "#1BA6C8",
            warning: "#F0AD4E",
            accent: "#263238",
            ...customColors,
            admin: "#D500F9",
          },
        },
        civil: {
          /**
           * leem rood - #f6b09d
           * baksteen rood - #f28e77
           * klinker rood - #ed694b
           * fundament rood - #e94e24
           */
          dark: false,
          variables: {
            domain: DomainType.CIVIL,
          },
          colors: {
            primary: "#54494B", // Primary elements
            secondary: "#B1A9A1", // Secondary elements
            tertiary: "#3C3F45", // Highlights or emphasis
            quaternary: "#696b6e",
            background: "#FBF8FA",
            surface: "#F0EBE7",
            error: "#D32F2F",
            success: "#388E3C",
            info: "#1976D2",
            warning: "#FFA000",
            ...customColors,
          },
        },
        kanters: {
          dark: false,
          variables: {
            organization: "5d109f1e0f31855478eb9537",
          },
          colors: {
            /**
             * #e01036
             * #bad7e8
             * #66666f
             * #c0c4b3
             * #a4b6ce
             */
            background: "#c0c4b3",
            surface: "#f5f5f5",
            primary: "#66666f",
            secondary: "#e01036",
            tertiary: "#e01036",
            error: "#B00020",
            info: "#2196F3",
            success: "#4CAF50",
            warning: "#FB8C00",
            ...customColors,
          },
        },
      },
    },

    locale: {
      locale: "nl",
      fallback: "en",
      messages: { en, nl },
    },

    date: {
      locale: {
        en: "nl",
        nl: "nl",
      },
    },
  })

  vueApp.use(vuetify)
})
